import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to top on every route change.
 * Respects hash anchors (so /#programs still works) and admin iframe preview
 * (admin/* routes never need to be scroll-managed at the top window).
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a hash, let the browser handle anchor scrolling instead.
    if (hash) return;
    // Don't fight with the admin live-preview iframe scrolling logic.
    if (pathname.startsWith("/admin")) return;
    // Scroll synchronously, then again after the first paint to catch any
    // async-mounted CMS content shifting layout below the fold.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const raf = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
};
